export const selectRouterLocation = state => state.router.location
